// extracted by mini-css-extract-plugin
export var boxItems = "_24-1";
export var boxItemsLg = "_24-2";
export var button = "_24-7";
export var buttonHoverless = "_24-9";
export var buttonLg = "_24-8";
export var filterGroupBox = "_24-0";
export var icon = "_24-3";
export var iconSecondary = "_24-6";
export var iconWrapper = "_24-4";
export var iconWrapperLg = "_24-5";
export var truncatedLabel = "_24-a";